export default {
  path: '/software',
  name: 'software',
  component: () => import('../components/software/Layout'),
  redirect: { name: 'SoftwareList' },
  meta: {
    breadcrumb: 'profile.software.softwares',
  },
  children: [
    {
      name: 'SoftwareList',
      path: '',
      component: () => import('../views/software/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'SoftwareCreate',
      path: 'new',
      component: () => import('../views/software/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'SoftwareUpdate',
      path: ':id/edit',
      component: () => import('../views/software/Update'),
      meta: {
        breadcrumb: 'profile.software.software',
      },
    },
    {
      name: 'SoftwareShow',
      path: ':id',
      component: () => import('../views/software/Show'),
      meta: {
        breadcrumb: 'profile.software.software',
      },
    }
  ]
};
